// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/tdg-organisation-event-schema',
  type: 'object',
  required: ['id', 'creatorId', 'organisationId', 'eventId'],
  properties: {
    id: {
      type: 'integer',
    },
    creatorId: {
      type: 'integer',
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    organisationId: {
      type: 'integer',
    },
    eventId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
